// extracted by mini-css-extract-plugin
export default {"container":"DeleteAccount_container__eXu01","title":"DeleteAccount_title__BpsjV","text":"DeleteAccount_text__1lIZy"};